export function initMarqueeRevealBlocks() {
	const blocks = document.querySelectorAll('[data-marquee-reveal]');
	if (!blocks.length) {
		return;
	}

	const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
	const states = [];
	let lastFrameTime = 0;
	let rafId = 0;
	let resizeRafId = 0;

	const rebuildStates = () => {
		states.length = 0;
		blocks.forEach((block) => {
			const state = setupMarqueeRevealBlock(block);
			if (state) {
				states.push(state);
			}
		});
		lastFrameTime = 0;
	};

	const animate = (time) => {
		if (!states.length || reduceMotionQuery.matches) {
			rafId = 0;
			return;
		}

		if (!lastFrameTime) {
			lastFrameTime = time;
		}

		const deltaSeconds = (time - lastFrameTime) / 1000;
		lastFrameTime = time;

		for (let i = 0; i < states.length; i += 1) {
			const state = states[i];
			if (state.shift <= 0 || state.pixelsPerSecond <= 0) {
				continue;
			}

			state.offset = (state.offset + state.pixelsPerSecond * deltaSeconds) % state.shift;
			state.track.style.transform = `translate3d(${-state.offset}px, 0, 0)`;
		}

		rafId = window.requestAnimationFrame(animate);
	};

	const startAnimation = () => {
		if (rafId || reduceMotionQuery.matches || !states.length) {
			return;
		}
		rafId = window.requestAnimationFrame(animate);
	};

	const stopAnimation = () => {
		if (!rafId) {
			return;
		}
		window.cancelAnimationFrame(rafId);
		rafId = 0;
		lastFrameTime = 0;
	};

	const onResize = () => {
		if (resizeRafId) {
			window.cancelAnimationFrame(resizeRafId);
		}

		resizeRafId = window.requestAnimationFrame(() => {
			rebuildStates();
			stopAnimation();
			startAnimation();
		});
	};

	const onVisibilityChange = () => {
		lastFrameTime = 0;
	};

	const onMotionPreferenceChange = () => {
		if (reduceMotionQuery.matches) {
			stopAnimation();
			for (let i = 0; i < states.length; i += 1) {
				states[i].track.style.transform = 'translate3d(0, 0, 0)';
				states[i].offset = 0;
			}
			return;
		}

		startAnimation();
	};

	rebuildStates();
	startAnimation();

	window.addEventListener('resize', onResize);
	document.addEventListener('visibilitychange', onVisibilityChange);
	reduceMotionQuery.addEventListener('change', onMotionPreferenceChange);
}

function setupMarqueeRevealBlock(block) {
	const track = block.querySelector('[data-marquee-mask-track]');
	const text = block.querySelector('[data-marquee-mask-text]');
	const textCopy = block.querySelector('[data-marquee-mask-text-copy]');
	if (!track || !text || !textCopy) {
		return null;
	}

	const width = text.getComputedTextLength();
	if (!Number.isFinite(width) || width <= 0) {
		return null;
	}

	const gap = Math.max(120, Math.round(width * 0.08));
	const shift = Math.round(width + gap);
	textCopy.setAttribute('x', String(shift));
	block.style.setProperty('--marquee-shift', `-${shift}px`);

	const durationRaw = Number.parseFloat(block.getAttribute('data-marquee-duration') || '');
	const duration = Number.isFinite(durationRaw) && durationRaw > 0 ? durationRaw : 22;
	const pixelsPerSecond = shift / duration;

	track.style.transform = 'translate3d(0, 0, 0)';

	return {
		track,
		shift,
		pixelsPerSecond,
		offset: 0,
	};
}
